import React from 'react';
import {personal, about, skills, secondarySkills} from '../data';

export default function About() {
    return (
        <section id="about" style={{
            padding: '6rem 2.5rem',
            maxWidth: '900px', margin: '0 auto',
            fontFamily: "'DM Mono', monospace",
        }}>
            <div style={{
                fontSize: '10px', letterSpacing: '0.22em',
                textTransform: 'uppercase', color: '#9b9991',
                marginBottom: '3rem',
                display: 'flex', alignItems: 'center', gap: '1rem',
            }}>
                About
                <span style={{flex: 1, height: '0.5px', background: 'rgba(100,98,92,0.15)', maxWidth: '60px'}}/>
            </div>

            {/* Bio */}
            <div style={{
                marginBottom: '4rem',
                paddingBottom: '4rem',
                borderBottom: '0.5px solid rgba(100,98,92,0.15)',
            }}>
                <p style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    fontWeight: 300, lineHeight: 1.75,
                    color: '#2e2d2a', marginBottom: '1.5rem',
                }}>
                    A student of the world, lover of puzzles, and vanquisher of challenges.
                </p>
                <p style={{
                    fontSize: '13px', color: '#6b6963',
                    lineHeight: 1.9, letterSpacing: '0.03em',
                    maxWidth: '620px', marginBottom: '1.25rem',
                }}>
                    With a varied background and wide skill set, I create solutions that merge form and function. My
                    approach combines creative problem-solving with growing technical expertise to overcome challenges.
                </p>
                <p style={{
                    color: '#9b9991',
                    lineHeight: 1.9, letterSpacing: '0.03em',
                    maxWidth: '620px', fontStyle: 'italic',
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: '17px', fontWeight: 300,
                }}>
                    When not programming, you'll find me cooking, slinging arrows, playing music, or learning something
                    new.
                </p>
            </div>

            {/* Details grid */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                gap: '4rem', alignItems: 'start',
            }}>
                <p style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: '22px', fontWeight: 300,
                    lineHeight: 1.65, color: '#2e2d2a',
                }}>
                    {about}
                </p>

                <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem'}}>
                    {[
                        {label: 'Based in', value: personal.location},
                        {label: 'Focus', value: personal.focus},
                    ].map(({label, value}) => (
                        <div key={label} style={{
                            borderBottom: '0.5px solid rgba(100,98,92,0.15)',
                            paddingBottom: '1rem',
                        }}>
                            <div style={{
                                fontSize: '10px',
                                letterSpacing: '0.18em',
                                textTransform: 'uppercase',
                                color: '#9b9991',
                                marginBottom: '4px'
                            }}>
                                {label}
                            </div>
                            <div style={{fontSize: '13px', color: '#2e2d2a', letterSpacing: '0.03em'}}>
                                {value}
                            </div>
                        </div>
                    ))}

                    <div style={{borderBottom: '0.5px solid rgba(100,98,92,0.15)', paddingBottom: '1rem'}}>
                        <div style={{
                            fontSize: '10px',
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#9b9991',
                            marginBottom: '8px'
                        }}>
                            Primary Stack
                        </div>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                            {skills.map((s) => (
                                <span key={s} style={{
                                    fontSize: '11px', letterSpacing: '0.08em',
                                    color: '#3d6e78',
                                    background: 'rgba(61,110,120,0.08)',
                                    border: '0.5px solid rgba(61,110,120,0.2)',
                                    padding: '4px 12px', borderRadius: '20px',
                                }}>
                  {s}
                </span>
                            ))}
                        </div>

                        <div style={{paddingBottom: '1rem', paddingTop: '1rem'}}>
                            <div style={{
                                fontSize: '10px',
                                letterSpacing: '0.18em',
                                textTransform: 'uppercase',
                                color: '#9b9991',
                                marginBottom: '8px'
                            }}>
                                Additional Skills
                            </div>
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                                {secondarySkills.map((s) => (
                                    <span key={s} style={{
                                        fontSize: '11px', letterSpacing: '0.08em',
                                        color: '#3d6e78',
                                        background: 'rgba(61,110,120,0.08)',
                                        border: '0.5px solid rgba(61,110,120,0.2)',
                                        padding: '4px 12px', borderRadius: '20px',
                                    }}>
                  {s}
                </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}